export default "__VITE_ASSET__xkhHoUS3__"